/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Type of identity of card holder. Currently only individual is supported.

 */
export type CreateCardAccountBodyIdentityType = typeof CreateCardAccountBodyIdentityType[keyof typeof CreateCardAccountBodyIdentityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCardAccountBodyIdentityType = {
  individual: 'individual',
} as const;
